import Vue from 'vue'
import Vuex from 'vuex'



Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        mostraFormulario: true,
        mostraVirtual: false,
        mostraPresencial: false,
        cadastroIgo: true,
        interesse: false,
        corSecundaria: "#dc9e09",
        pax: [],
        barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
        isMenuVisivel: false,
        drawer: null,
        MostraCadastro: false,
        mostraBtnInscreva: null,
        mostraLogin: false,
        titulos: null,
        icones: null,
        evento: [],
        selIdEvento: null,
        PanelEvento: false,
        banco: String,
        selIdAgencia: null,
        selIdCliente: null,
        selEtapas: null,
        chatSuporte: false,
        LinkVirtual: 'https://eventosdigitais.live/evento/HER2-baixaexpressao-Her2Low/',
        siteIgo: 'https://astrazeneca3.igorsvp.com.br', //'https://localhost:44351',
        dadosEvento: {
            LinkVirtual: 'https://eventosdigitais.live/evento/HER2-baixaexpressao-Her2Low/',
            cliqueAqui: false,
            nome_evento_sistema: "MASTERCLASS HER2LOW",
            nome_evento: "MASTERCLASS HER2LOW",
            tituloExibicao: 'MASTERCLASS HER2LOW',
            subtituloEvento: ``,
            dataEventoLand: `17 DE OUTUBRO DE 2022`,
            comecou: `É AGORA`,
            id_evento: 1,
            data_inicio: "17/10/2022 18:00:00",
            data_termino: "17/10/2022 21:15:00",
            data_solicitacao: '20/09/2021',
            descricao: `
            A nova classificação de HER2 - Baixa Expressão (Her2Low) representa uma nova possibilidade às pacientes com câncer de mama metastático, abrindo o leque da classificação tumoral, que permite cada vez mais tratamentos personalizados.<br> 
            E você, patologista, é o personagem principal nessa nova jornada. <br>
            Participe conosco da Masterclass Patologia Her2-low teórica e prática que trará conhecimento e atualização de forma prática, leve e assertiva sobre a nova classificação e esse novo momento da Patologia na jornada da paciente com Câncer de Mama Metastático.<br> 
            Venha saber mais sobre como juntos, poderemos transformar vidas e reescrever histórias.           
            
            `,
            link: {
                exibicaoIGO: true,
                link: 'https://google.com.br'
            },
            localEvento: [{
                    titulo: "São Paulo",
                    nome: 'JW Marriot - Torre Hotel',
                    rua: "Av. das Nações Unidas, 14401 - Chácara Santo Antônio",
                    cidade: "São Paulo - SP, 04794-000",
                    site: "",
                    mascara_site: "",
                    telefone: ""
                },
                {
                    titulo: "Rio de Janeiro",
                    nome: 'Hilton Copacabana',
                    rua: "Av. Atlântica, 1020 – Copacabana",
                    cidade: "Rio de Janeiro - RJ, 22010-000",
                    site: "",
                    mascara_site: "",
                    telefone: ""
                },
                {
                    titulo: "Porto Alegre",
                    nome: 'Hilton Moinhos de Vento',
                    rua: "R. Olávo Barreto Viana, 18 - Moinhos de Vento",
                    cidade: "Porto Alegre - RS, 90570-000",
                    site: "",
                    mascara_site: "",
                    telefone: ""
                },
                {
                    titulo: "Brasília",
                    nome: 'Complexo Brasil 21',
                    rua: "SHS Block 06 - Asa Sul, Brasília",
                    cidade: "Brasília - DF, 70316-102",
                    site: "",
                    mascara_site: "",
                    telefone: ""
                },
                {
                    titulo: "Belo Horizonte ",
                    nome: 'Mercure Lourdes',
                    rua: "Av. do Contorno, 7315 - Lourdes",
                    cidade: "Belo Horizonte - MG, 30110-047",
                    site: "",
                    mascara_site: "",
                    telefone: ""
                },

                {
                    titulo: "Fortaleza ",
                    nome: 'Luzeiros',
                    rua: "Av. Beira Mar, 2600 - Meireles",
                    cidade: "Fortaleza - CE, 60165-121",
                    site: "",
                    mascara_site: "",
                    telefone: ""
                },

            ],

        },

        palestrantes: [


            {
                color: "transparent",
                src: "https://cdn.igorsvp.com.br/landpages/speakers/her2low/Anezka Ferrari.jpeg",
                title: "Dra Anezka Ferrari",
                subtitle: ``,
                palestrante: `Médica Oncologista Clínica formada pela Faculdade de Medicina da USP (FMUSP).
                Residência em Clínica Médica e Oncologia Clínica pela FMUSP.
                Certificado de Proficiência em Câncer de Mama pela European School of Oncology (ESO).
                Doutoranda em Ciências da Saúde no Hospital Sírio Libanês.
                Atua como Médica Oncologista no Hospital Santa Paula - DASA.
                `
            },
            {
                color: "transparent",
                src: "https://cdn.igorsvp.com.br/landpages/speakers/her2low/Alexandre Moreira.jpeg",
                title: "Dr Alexandre Moreira",
                subtitle: ``,
                palestrante: `Médico Patologista formado pela Universidade do Pará.
                Residência em anatomia Patológica pelo AC Camargo Câncer Center
                Atua como Médico Patologista rede DASA.
                `
            },


        ],
        programacaoUnico: {
            horarios: [
                `19H30`,
                "20H00",
                "21H00",
            ],
            texto: [
                `Apresentação do Preceptoship Instituto Wilson Mello`,
                `Osteoartrite: Importância e Novos Conceitos`,
                `Opções Medicamentosas no Tratamento da OA`,
            ],
            textoCol3: [
                "Prof. Dr. Jorge Guedes",
                "Prof. Dr. Jorge Guedes",
                "Prof. Dr. Jorge Guedes",
            ],
        },
        programacao: [{

            },


        ],
        fechaForm: false,
        emailAcessoLogin: null,
        dataEvento: {},
        menu: [{
                text: 'Sair',
                mostra: false,
                id: 'sair'
            },
            {
                text: 'Inscreva-se',
                mostra: false,
                id: 'cadastrese',
                cor: '#f5cb5d',
                class: 'btn_inscr'

            },
            {
                text: 'Sobre',

                mostra: true,
                id: 'sobre'
            },
            {
                text: 'Speakers',
                mostra: true,
                id: 'informacoes',
            },
            {
                text: 'Programação',
                mostra: true,
                id: 'programacao',
            },
            {
                text: 'Locais',
                mostra: true,
                id: 'local'

            },


            {
                text: 'Contato',
                mostra: true,
                id: 'contato'

            },

        ],
        id_evento: null,
        mostraItemMenu: true,
        uf: ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"]
    },
    mutations: {
        toggleMenu(state, isVisible) {
            if (isVisible === undefined) {
                state.isMenuVisivel = !state.isMenuVisivel
            } else {
                state.isMenuVisivel = isVisible
            }
            console.log('toggleMenu = ' + state.isMenuVisivel)
        },
        SET_DRAWER(state, payload) {
            state.drawer = payload
        },
        SET_BAR_IMAGE(state, payload) {
            state.barImage = payload
        },
        mostraChat(state, payload) {
            state.chatSuporte = payload
        }
    },
    modules: {
        agenda1: {
            namespaced: true,
            state: () => ({
                programacao: [{

                        tab: "17 DE OUTUBRO",

                        header: [
                            // { text: "Horário", colspan: "2" },

                            // { text: "" },
                            // { text: "Atividade" },
                        ],
                        trs: [

                            { col1: `19:00`, col2: `19:15`, col3: `Abertura`, col4: " ", color: 'transparent' },
                            { col1: `19:15`, col2: `20:00`, col3: `Aula teórica: Avanços no tratamento do câncer de mama HER2-low: a visão do oncologista clínico`, col4: "Dra. Anezka Ferrari <br> Oncologista", fonte4: '#f5cb5d', color: 'transparent' },
                            { col1: `20:00`, col2: `20:15`, col3: `Dúvidas e debate sobre aula teórica`, col4: " ", color: 'transparent' },
                            { col1: `20:15`, col2: `21:00`, col3: `Aula prática: Aplicação prática sobre análise das lâminas frente à nova classificação histológica`, col4: "Dr Flávio Alexandre Moreira <br>Patologista", fonte4: '#f5cb5d', color: 'transparent' },
                            { col1: `21:00`, col2: `21:15`, col3: `Dúvidas e debate sobre aula prática`, col4: " ", color: 'transparent' },
                            { col1: `21:15`, col2: `22:45`, col3: `Jantar`, col4: " ", color: 'transparent' },
                            { col1: `22:45`, col3: `Encerramento`, col4: " ", color: 'transparent' },

                        ],
                    },

                ],
            }),
            getters: {
                // isAdmin () { ... } // -> getters['account/isAdmin']
            },
            actions: {
                // login () { ... } // -> dispatch('account/login')
            },
            mutations: {
                //  login () { ... } // -> commit('account/login')
            },
        }

    },
})